var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#0061FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 24V26C25.0002 27.1046 24.1048 28 23.0002 28H13.0002C11.8957 28 11.0002 27.1046 11.0002 26V19C11.0002 17.8954 11.8957 17 13.0002 17H15.0002M18.0002 13H17.0002C15.8957 13 15.0002 13.8954 15.0002 15V22C15.0002 23.1046 15.8957 24 17.0002 24H27.0002C28.1048 24 29.0002 23.1046 29.0002 22V15C29.0002 13.8954 28.1048 13 27.0002 13H26.0002M25.0002 17L22.0002 20M22.0002 20L19.0002 17M22.0002 20L22.0002 11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBalance);
export default __webpack_public_path__ + "static/media/wallet-balance.77c81de46cd8125d0cca228a73533513.svg";
export { ForwardRef as ReactComponent };